/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Custom_Name_PlaceholderInputs */

const en_embed_captions_custom_name_placeholder = /** @type {(inputs: Embed_Captions_Custom_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter custom name (optional)`)
};

const fr_embed_captions_custom_name_placeholder = /** @type {(inputs: Embed_Captions_Custom_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrez un nom personnalise (facultatif)`)
};

const de_embed_captions_custom_name_placeholder = /** @type {(inputs: Embed_Captions_Custom_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie einen benutzerdefinierten Namen ein (optional).`)
};

const it_embed_captions_custom_name_placeholder = /** @type {(inputs: Embed_Captions_Custom_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci un nome personalizzato (facoltativo)`)
};

const ru_embed_captions_custom_name_placeholder = /** @type {(inputs: Embed_Captions_Custom_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Введите пользовательское имя (необязательно)`)
};

const es_embed_captions_custom_name_placeholder = /** @type {(inputs: Embed_Captions_Custom_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduzca un nombre personalizado (opcional)`)
};

const zh_cn2_embed_captions_custom_name_placeholder = /** @type {(inputs: Embed_Captions_Custom_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入自定义名称（可选）`)
};

const ja_embed_captions_custom_name_placeholder = /** @type {(inputs: Embed_Captions_Custom_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カスタム名を入力してください（オプション）`)
};

const hi_embed_captions_custom_name_placeholder = /** @type {(inputs: Embed_Captions_Custom_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपना मनचाहा नाम दर्ज करें (वैकल्पिक)`)
};

const pt_pt2_embed_captions_custom_name_placeholder = /** @type {(inputs: Embed_Captions_Custom_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insira um nome personalizado (opcional)`)
};

/**
* | output |
* | --- |
* | "Enter custom name (optional)" |
*
* @param {Embed_Captions_Custom_Name_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_custom_name_placeholder = /** @type {((inputs?: Embed_Captions_Custom_Name_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Custom_Name_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_custom_name_placeholder(inputs)
	if (locale === "de") return de_embed_captions_custom_name_placeholder(inputs)
	if (locale === "it") return it_embed_captions_custom_name_placeholder(inputs)
	if (locale === "ru") return ru_embed_captions_custom_name_placeholder(inputs)
	if (locale === "es") return es_embed_captions_custom_name_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_custom_name_placeholder(inputs)
	if (locale === "ja") return ja_embed_captions_custom_name_placeholder(inputs)
	if (locale === "hi") return hi_embed_captions_custom_name_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_custom_name_placeholder(inputs)
	return en_embed_captions_custom_name_placeholder(inputs)
});